import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-modelos',
  templateUrl: './modelos.component.html',
  styleUrls: ['./modelos.component.scss']
})
export class ModelosComponent implements OnInit {

  constructor(
		public globals: Globals,
		private productoService: ProductoService,
		private router: Router,
  ) { }

  seleccionarModelo( modelo ){
    //this.globals.configuracion.front.listado.modelo = modelo.idmodelo;
    this.globals.configuracion.front.listado.modelo = modelo.idmodelo;
    this.globals.setDataFront();

    this.router.navigate(['/catalogo']);
  }

  modelos = {
    cargando: true,
    registros: new Array()
  }

  modelosListado(){
    this.modelos.cargando = true;

    this.productoService.modelosListado({
      marca: this.globals.configuracion.front.listado.marca
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          if( resultado.registros.length == 0 ){
            this.router.navigate(['/catalogo']);
            return ;
          }
          Array.prototype.push.apply( this.modelos.registros, resultado.registros );
          this.modelos.cargando = false;
        }else{
          console.log("Error",resultado.mensaje);
        }

      },
      error =>{
        console.log("Error",error);
        //this.feedProductos.cargando = false;
      }
    )
  }

  ngOnInit(): void {
    this.modelosListado();
  }

}
